<mat-card appearance="outlined" class="risk-panel">
  <mat-card-content>
    <h2 class="section-title">
      <app-icon [name]="icon()" [size]="18" />
      <span>{{ heading() }}</span>
    </h2>

    <dl class="facts">
      @for (field of riskSummary().fields; track field.key) {
        <div class="facts__row" [class.facts__row--warning]="field.tone === 'warning'">
          <dt>{{ field.label }}</dt>
          <dd>
            @if (isPending(field)) {
              <span class="risk-panel__pending">Pending</span>
            } @else {
              @switch (field.kind) {
                @case ('currency') {
                  {{ field.value | zar }}
                }
                @case ('months') {
                  {{ field.value }} months
                }
                @case ('percent') {
                  {{ field.value }}%
                }
                @case ('status') {
                  <app-status-chip [status]="field.value + ''" />
                }
                @default {
                  {{ field.value | dash }}
                }
              }
            }
          </dd>
        </div>
      }
    </dl>

    @if (hasPending()) {
      <p class="risk-panel__note">
        Pending values are computed by the rules engine in a later phase — they are not a data error
        and do not block your decision.
      </p>
    }
  </mat-card-content>
</mat-card>
